const LOCALE_PREFIX_PATTERN = /^\/(en|zh)(\/|$)/;

export function getLocalizedHref(href: string, locale: string) {
    if (
        !href ||
        href.startsWith('#') ||
        href.startsWith('http://') ||
        href.startsWith('https://') ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:')
    ) {
        return href;
    }

    const normalizedHref = href.startsWith('/') ? href : `/${href}`;

    if (LOCALE_PREFIX_PATTERN.test(normalizedHref)) {
        return normalizedHref;
    }

    if (normalizedHref === '/') {
        return `/${locale}`;
    }

    return `/${locale}${normalizedHref}`;
}
